import { TableContainer as MUITableContainer } from '@mui/material';
import styled from '@emotion/styled';
import Theme from 'App.theme';

export const TableContainer = styled(MUITableContainer)`
  border: 2px solid ${Theme.greys.GREY1};
  border-radius: 5px;
  box-shadow: none;
  transition: all 0.3s;
  max-height: 100%;
  & .set-table: {
    & .muitablebody-root: {
      & .muitablerow-root: {
        &:hover: {
          cursor: default;
          background: #ffffff;
        }
      }
    }
  }
  & .muitablehead-root: {
    cursor: default;
    & .tray-header: {
      padding: 0rem;
    }
    & .muitablecell-head: {
      color: Theme.colours.black;
      background: Theme.greys.GREY1;
    }
  }
  & .parts: {
    & .muitablecell-root: {
      padding: 0.5rem;
    }
  }
  & .muitablecell-root: {
    font-family: Poppins, sans-serif;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 15rem;
  }
  & .actions: {
    max-width: 3rem;
  }
  & .muitablebody-root: {
    & .default: {
      &:hover: {
        cursor: default;
        background: unset;
      }
    }
    & .muitablerow-root: {
      transition: all 0.3s;
      & td: {
        border-bottom: 2px solid ${Theme.greys.GREY1};
      }
      &:last-child: {
        & td: {
          border-bottom: 0px;
        }
      }
      &:hover: {
        cursor: pointer;
        background: #f4f4f4;
      }
    }
  }
`;
